import React, {useState, useEffect} from 'react'
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import {makeStyles} from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Logo from '../assets/logo.svg'
import axios from "axios";
import Alert from '@material-ui/lab/Alert';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import {AlertTitle} from "@material-ui/lab";
import {CircularProgress} from "@material-ui/core";
import {useLocation} from "react-router-dom"

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'© '}
            <Link color="inherit" href="https://material-ui.com/">
                kamtridit.cz
            </Link>{' '}
            {new Date().getFullYear()}
        </Typography>
    )
}

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: 'black',
        paddingTop: 5,
        paddingBottom: 0,
        paddingRight: 30,
        paddingLeft: 30,
        width: '100%',
        marginBottom: 30,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        height: 50,
    },
    alert: {
        width: '100%',
        marginTop: theme.spacing(2),
    },
    loader: {
        marginTop: 20,
    },
    link: {
    cursor: 'pointer',
}
}))

export default function ResetPassword() {
    const classes = useStyles()

    const [user, setUser] = useState({ password: '', password2: ''})
    const [error, setError] = useState({password: false, password2: false})
    const [openAlert, setOpenAlert] = useState(false)
    const [errorMessage, setErrorMessage] = useState('Chyba. Zkuste prosim pozdeji.')
    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)
    const search = useLocation().search

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!handleValidity()) {
            return
        }
        setLoading(true)

        axios.post(`${process.env.REACT_APP_API}/api/auth/password/reset`,
            {password: user.password, token: token}
        )
            .then(response => {
                setLoading(false)
                setSubmitted(true)
            })
            .catch(error => {
                setLoading(false)
                if (error.response.data.message) {
                    setErrorMessage(error.response.data.message)
                }
                setOpenAlert(true)
            })
    }

    const handleError = (field) => {
        if (field === 'password') {
            setError({...error, password: !(user.password.length >= 8)})
        } else if (field === 'password2') {
            setError({...error, password2: !(user.password === user.password2)})
        }
    }

    const handleValidity = () => {
        return (user.password.length >= 8 && user.password === user.password2)
    }

    const emailIsValid = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }

    const valid = handleValidity()

    const token = new URLSearchParams(search).get('token')

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline/>
            <div className={classes.paper}>
                <div className={classes.avatar}>
                    <img src={Logo}/>
                </div>
                <Typography component="h1" variant="h5">
                    NOVÉ HESLO
                </Typography>
                {loading === true &&
                <CircularProgress className={classes.loader}/>
                }
                {submitted === true &&
                <Alert severity="success" className={classes.alert}>
                    <AlertTitle>Heslo bylo resetováno</AlertTitle>
                    <Link to="" className={classes.link}
                          onClick={() => window.location.href = "/uzivatel/prihlaseni"} variant="body2">
                        Můžete se přihlásit.
                    </Link>
                </Alert>
                }
                {submitted === false && loading === false &&
                <>
                    <Collapse in={openAlert} className={classes.alert}>
                        <Alert severity="error"
                               action={
                                   <IconButton
                                       aria-label="close"
                                       color="inherit"
                                       size="small"
                                       onClick={() => {
                                           setOpenAlert(false)
                                       }}
                                   >
                                       <CloseIcon fontSize="inherit"/>
                                   </IconButton>
                               }
                        >
                            {errorMessage}
                        </Alert>
                    </Collapse>
                    <form className={classes.form} onSubmit={handleSubmit}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            placeholder={'heslo min. 8 znaků'}
                            required
                            fullWidth
                            name="password"
                            label="Heslo"
                            type="password"
                            id="password"
                            value={user.password}
                            onChange={e => {
                                setUser({...user, password: e.target.value})
                            }}
                            onBlur={(e) => {
                                handleError(e.target.name)
                            }}
                            error={error.password}
                            helperText={error.password ? 'Nevalidní heslo' : ' '}
                            autoFocus
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            placeholder={'hesla se musí shodovat'}
                            required
                            fullWidth
                            name="password2"
                            label="Heslo znovu"
                            type="password"
                            id="password2"
                            value={user.password2}
                            onChange={e => {
                                setUser({...user, password2: e.target.value})
                            }}
                            onBlur={(e) => {
                                handleError(e.target.name)
                            }}
                            error={error.password2}
                            helperText={error.password2 ? 'Hesla se musí shodovat' : ' '}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            disabled={!valid}
                            color="primary"
                            className={classes.submit}
                        >
                            Resetovat heslo
                        </Button>
                    </form>
                    <Box mt={8}>
                        <Copyright/>
                    </Box>
                </>
                }
            </div>
        </Container>
    )
}